import React, { lazy, Suspense } from 'react';
import NovaAIBackground from './NovaAIBackground';
import About from './About';

const Projects = lazy(() => import('./Projects'));
const Tools = lazy(() => import('./Tools'));
const Contact = lazy(() => import('./Contact'));
const Footer = lazy(() => import('./Footer'));

const SectionFallback = () => (
  <div className="w-full h-64 flex items-center justify-center bg-transparent">
    <div className="w-8 h-8 border-2 border-white/40 border-t-transparent rounded-full animate-spin" />
  </div>
);

export default function PortfolioSections() {
  return (
    <div
      id="cinematic-portfolio"
      className="nova-cinematic-wrapper relative w-full overflow-x-clip"
      aria-label="Portfolio Content"
    >
      {/* Sticky Cinematic Viewport Layer (pinned continuously across About -> Footer) */}
      <div className="nova-cinematic-sticky sticky top-0 h-screen w-full pointer-events-none z-0 overflow-hidden">
        <NovaAIBackground />
      </div>

      {/* Cinematic Content Layer (overlays the sticky video background) */}
      <div className="nova-cinematic-content relative z-10 -mt-[100vh] text-gray-900">
        <About />

        <Suspense fallback={<SectionFallback />}>
          <Projects />
        </Suspense>

        <Suspense fallback={<SectionFallback />}>
          <Tools />
        </Suspense>

        <Suspense fallback={<SectionFallback />}>
          <Contact />
        </Suspense>

        <Suspense fallback={<SectionFallback />}>
          <Footer />
        </Suspense>
      </div>
    </div>
  );
}
